import "react-i18next";
import type zhCommon from "./locales/zh/common.json";
import type zhSidebar from "./locales/zh/sidebar.json";
import type zhPages from "./locales/zh/pages.json";
import type zhSettings from "./locales/zh/settings.json";

// 定义支持的语言
export type SupportedLanguage = "en" | "zh";

// 定义命名空间
export type Namespace = "common" | "sidebar" | "pages" | "settings";

// 扩展 react-i18next 的类型定义
declare module "react-i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: {
      common: typeof zhCommon;
      sidebar: typeof zhSidebar;
      pages: typeof zhPages;
      settings: typeof zhSettings;
    };
  }
}

export interface LanguageOption {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
}

export const languageOptions: LanguageOption[] = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "zh", name: "Chinese", nativeName: "中文" },
];
